import { render, staticRenderFns } from "./MediaGalleryModal.vue?vue&type=template&id=044c4dfa&scoped=true"
import script from "./MediaGalleryModal.vue?vue&type=script&lang=js"
export * from "./MediaGalleryModal.vue?vue&type=script&lang=js"
import style0 from "./MediaGalleryModal.vue?vue&type=style&index=0&id=044c4dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c4dfa",
  null
  
)

export default component.exports